export const getImageURL = (path) => {
    return 'assets/' + path;
}